// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__TNcI9","legacyBtn":"MutateMid_legacyBtn__16MCu"};